<template>
  <div class="pulse">
    <div class="loader" :class="{ rounded }" :style="{ width, height, borderRadius, aspectRatio, opacity }" />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  rounded?: boolean
  width?: string
  height?: string
  borderRadius?: string
  aspectRatio?: string
  opacity?: number
}>()
</script>

<style lang="scss" scoped>
.pulse {
  @include animate-pulse;
}

.loader {
  width: 100%;
  height: 40px;
  background-color: $grey-50;

  &.rounded {
    border-radius: $spacing-3;
  }
}
</style>
